/* global ProgressBar, Rydges */
import helpers from '../util/helpers';

export default {
  init() {
    // JavaScript to be fired on the home page

    // Home slider
    const homeSliderBg = $('.section-home-slider .slider-bg');
    const homeSliderContent = $('.section-home-slider .slider-content');
    if (homeSliderBg.length) {
      // hero slider circle loader
      let circleLoader = $('.section-home-slider .circle-loader');
      if (circleLoader.length) {
        let bar = new ProgressBar.Circle('.circle-loader', {
          strokeWidth: 12,
          easing: 'easeInOut',
          duration: 500,
          color: '#871c3c',
          trailColor: '#ccc',
          trailWidth: 9,
          svgStyle: null,
        });
        bar.animate(1);

        homeSliderBg.on('init', function() {
          circleLoader.fadeOut();
        });
      }

      let sliderAutoplay = homeSliderBg.data('slider-auto-speed');
      let sliderCustomSpeed = homeSliderBg.data('slider-custom-speed');

      homeSliderBg.slick({
        dots: false,
        infinite: true,
        speed: typeof sliderCustomSpeed !== 'undefined' ? sliderCustomSpeed : 500,
        fade: true,
        arrows: false,
        cssEase: 'ease-in-out',
        autoplay: typeof sliderAutoplay !== 'undefined' ? true : false,
        autoplaySpeed: typeof sliderAutoplay !== 'undefined' ? sliderAutoplay : 0,
        asNavFor: homeSliderContent,
      });

      homeSliderContent.slick({
        dots: false,
        infinite: true,
        fade: true,
        arrows: true,
        appendArrows: '.section-home-slider .slider-nav',
        asNavFor: homeSliderBg,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              fade: false,
              centerPadding: '20px',
            },
          },
        ],
      });

      if (helpers.isMobile()) {
        helpers.equalHeightElements('.section-home-slider .slider-content .equal-height');
      }
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalHomepage.js